import { AxiosError } from 'axios'
import jwtDecode from 'jwt-decode'
import Swal2 from 'sweetalert2'

export const { isArray } = Array
export const { keys } = Object
/**
 * Description
 * @template [T=any]
 * @param {T} object
*/
export const deepClone = object => {
  if (typeof object !== 'object') return object
  if (object instanceof Set) {
    /** @type {any} */
    const set = new Set(object)
    return set
  }
  if (object instanceof Map) return new Map(object)
  const target = Object.assign(isArray(object) ? [] : {}, object)
  for (const key in target) {
    const property = object[key]
    if (typeof property === 'object') {
      target[key] = deepClone(property)
      continue
    }
    target[key] = object[key]
  }
  const result = target
  return result
}

/**
 * Description
 * @param {Date} date
 */
export const formatDateUS = date => {
  /** @type {Intl.DateTimeFormatOptions} */
  const options = { year: 'numeric', month: '2-digit', day: '2-digit' }
  return new Intl.DateTimeFormat('en-US', options).format(date)
}

/**
 * Description
 * @param {Date} date
 */
export const formatDateTimeUS = date => {
  /** @type {Intl.DateTimeFormatOptions} */
  const options = { year: 'numeric', month: '2-digit', day: '2-digit', hour12: true, hour: '2-digit', minute: '2-digit', }
  return new Intl.DateTimeFormat('en-US', options).format(date)
}

/**
 * Description
 * @template [T=Record<string,any>]
 * @param {T} formState
 * @param {T} initialData
 */
export const resetForm = (formState, initialData) => {
  Object.assign(formState, deepClone(initialData))
}

/**
 * Description
 * @param {string} data
 */
export const decodeBase64Blob = (data) => {
  const buffer = atob(data)
  const { length } = buffer
  const arrayBuffer = new ArrayBuffer(length)
  const uintArray = new Uint8Array(arrayBuffer)
  for (let i = 0; i < length; i++) {
    uintArray[i] = buffer.charCodeAt(i)
  }
  return uintArray
}

/**
 * Description
 * @template [T=Record<string, any>]
 * @param {T} object
 * @returns {Array<keyof T>}
 */
export const objectKeys = (object) => {
  /** @type {any} */
  const keys = Object.keys(object)

  return keys
}


export const LoadingPopup = Swal2.mixin({
  title: 'Loading...',
  icon: 'info',
  allowOutsideClick: false,
  didOpen() {
    Swal2.showLoading()
  },
})

export const ErrorPopup = Swal2.mixin({
  title: 'Error',
  icon: 'error',
  text: 'Oops something went wrong!!!',
  allowEscapeKey: true,
  allowEnterKey: true,
  showConfirmButton: true,
  didOpen() {
    Swal2.hideLoading()
  },
})

export const SuccessPopup = Swal2.mixin({
  title: 'Success',
  icon: 'success',
  allowEscapeKey: true,
  allowEnterKey: true,
  showConfirmButton: true,
  didOpen() {
    Swal2.hideLoading()
  },
})

export const ConfirmPopup = Swal2.mixin({
  title: 'Confirm Void Receipt',
  icon: 'info',
  html: `
    <p>Are you sure you want to void this receipt?</p>
  `,
  showCloseButton: true,
  showCancelButton: true,
  focusConfirm: false,
  confirmButtonText: 'Confirm',
  cancelButtonText: 'Cancel',
})

/**
 * Description
 * @param {Date} date
 */
export const toISOString = (date) => new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString().slice(0, 16)

export const decodeExpiry = token => {
  if (!token) return
  const { exp } = jwtDecode(token)
  return new Date(new Date(0).setUTCSeconds(exp))
}


/**
 * Description
 * @param {Date} date
 * @returns {string}
 */
export function getCurrentDate(date = new Date(), format = 'sv-SE') {
  const options = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }
  const formatter = new Intl.DateTimeFormat(format, options)
  const formattedDate = formatter.format(date)
  return formattedDate
}

/**
 * Description
 * @param {number} val
 * @returns {string}
 */
export const currencyFormat = function (val) {
  if (!val) return '-'
  if (val < 0) return `(${currencyFormat(Math.abs(val))})`
  return new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(val)
}


export const confirmPrompt = (answer, message, errorMessage = 'Confirmation text did not match.') => {
  if (!answer) throw new Error('Error argument [answer] is invalid')
  const input = window.prompt(message || `Type "${answer}" to confirm this action!`)
  if (!input) return false
  if (input.trim().toUpperCase() !== answer) {
    console.log('popup')
    ErrorPopup.fire('Error', errorMessage)
    return false
  }
  return true
}

/**
 * Description
 * @param {Blob} blob
 * @param {(url: string) => void} [callback]
 */
export const loadPdf = function (blob, callback) {
  const fileURL = URL.createObjectURL(blob)
  callback?.(fileURL)
  window.open(fileURL, '_blank')
  URL.revokeObjectURL(fileURL)
}

/**
 * Description
 * @param {string} text
 * @param {string} search
 * @returns {string}
 */
export const highlightText = (text, search) => {
  if (!search) return text
  const regex = new RegExp(`(${search})`, 'gi')
  return text.replace(regex, '<mark>$1</mark>')
}